module.exports = __webpack_public_path__ + "static/media/event-24px.2a14a81e.png";